import { render } from "./BlockTextStatement.vue?vue&type=template&id=775d5088&lang=pug"
import script from "./BlockTextStatement.vue?vue&type=script&lang=js"
export * from "./BlockTextStatement.vue?vue&type=script&lang=js"

import "./BlockTextStatement.vue?vue&type=style&index=0&id=775d5088&lang=scss"

import exportComponent from "/Users/redbot/nodeApps/thinkhub-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__